import {lazy, FC, Suspense, useEffect} from 'react'
import {Route, Routes, Navigate, useLocation} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'

const PrivateRoutes = () => {
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const {pathname} = useLocation()
  // const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))

  // Master
  const BankWrapper = lazy(() => import('../modules/bank/BankWrapper'))
  const ColourWrapper = lazy(() => import('../modules/colour/ColourWrapper'))
  const CustomerWrapper = lazy(() => import('../modules/customer/CustomerWrapper'))
  const ProductWrapper = lazy(() => import('../modules/product/ProductWrapper'))
  const ProductCategoryWrapper = lazy(() => import('../modules/product_category/ProductCategoryWrapper'))
  const ProductArticleWrapper = lazy(() => import('../modules/product_article/ProductArticleWrapper'))
  const UomWrapper = lazy(() => import('../modules/uom/UomWrapper'))

  // Transaction
  const TransactionWrapper = lazy(() => import('../modules/transaction/TransactionWrapper'))
  const TransactionProductWrapper = lazy(() => import('../modules/transaction_product/TransactionProductWrapper'))

  // Settings
  const AreaWrapper = lazy(() => import('../pages/settings/area/IndexWrapper'))
  const StoreWrapper = lazy(() => import('../pages/settings/store/StoreWrapper'))
  const UserManagementWrapper = lazy(() => import('../pages/settings/user-management/UserManagementWrapper'))

  // Report
  const SalesReportWrapper = lazy(() => import('../pages/report/sales/SalesWraper'))
  const ProductReportWrapper = lazy(() => import('../pages/report/product/ProductWrapper'))
  const StockAnalyzeWrapper = lazy(() => import('../pages/report/AnalisaStock/Wrapper'))

  useEffect(() => {}, [pathname])

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        {/* Lazy Modules */}

        {/* Master */}
        <Route
          path='master/bank/*'
          element={
            <SuspensedView>
              <BankWrapper />
            </SuspensedView>
          }
        />
        <Route
          path='master/barang/*'
          element={
            <SuspensedView>
              <ProductWrapper />
            </SuspensedView>
          }
        />
        <Route
          path='master/colour/*'
          element={
            <SuspensedView>
              <ColourWrapper />
            </SuspensedView>
          }
        />
        <Route
          path='master/customer/*'
          element={
            <SuspensedView>
              <CustomerWrapper />
            </SuspensedView>
          }
        />
        <Route
          path='master/product-category/*'
          element={
            <SuspensedView>
              <ProductCategoryWrapper />
            </SuspensedView>
          }
        />
        <Route
          path='master/product-article/*'
          element={
            <SuspensedView>
              <ProductArticleWrapper />
            </SuspensedView>
          }
        />
        <Route
          path='master/uom/*'
          element={
            <SuspensedView>
              <UomWrapper />
            </SuspensedView>
          }
        />

        {/* Transaction */}
        <Route
          path='transaction/*'
          element={
            <SuspensedView>
              <TransactionWrapper />
            </SuspensedView>
          }
        />
        <Route
          path='transaction/product/*'
          element={
            <SuspensedView>
              <TransactionProductWrapper />
            </SuspensedView>
          }
        />

        {/* Settings */}
        <Route
          path='settings/area/*'
          element={
            <SuspensedView>
              <AreaWrapper />
            </SuspensedView>
          }
        />
        <Route
          path='settings/store/*'
          element={
            <SuspensedView>
              <StoreWrapper />
            </SuspensedView>
          }
        />
        <Route
          path='settings/user-management/*'
          element={
            <SuspensedView>
              <UserManagementWrapper />
            </SuspensedView>
          }
        />

        {/* Report */}
        <Route
          path='report/sales/*'
          element={
            <SuspensedView>
              <SalesReportWrapper />
            </SuspensedView>
          }
        />
        <Route
          path='report/product/*'
          element={
            <SuspensedView>
              <ProductReportWrapper />
            </SuspensedView>
          }
        />
        <Route
          path='report/stock/*'
          element={
            <SuspensedView>
              <StockAnalyzeWrapper />
            </SuspensedView>
          }
        />

        {/* <Route
          path='crafted/pages/wizards/*'
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/widgets/*'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        /> */}
        <Route
          path='crafted/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        {/* <Route
          path='apps/chat/*'
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/user-management/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        /> */}
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--kt-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
